module.exports = __webpack_public_path__ + "static/img/AX.f2631f41.png";